/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * how was the message delivered to the user
 * @export
 */
export const MessageDeliveryType = {
    Personal: 'PERSONAL',
    Organisation: 'ORGANISATION'
} as const;
export type MessageDeliveryType = typeof MessageDeliveryType[keyof typeof MessageDeliveryType];


export function MessageDeliveryTypeFromJSON(json: any): MessageDeliveryType {
    return MessageDeliveryTypeFromJSONTyped(json, false);
}

export function MessageDeliveryTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessageDeliveryType {
    return json as MessageDeliveryType;
}

export function MessageDeliveryTypeToJSON(value?: MessageDeliveryType | null): any {
    return value as any;
}

